<template functional>
  <hour-time-format :type="props.row.hour_type" />
</template>

<script>
export default {
  name: 'HourTypeFormatter',
};
</script>
